import Vue from "vue";
import Vuex from "vuex";
import Axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "",
    token: localStorage.getItem("token") || "",
    user: JSON.parse(localStorage.getItem("user"))
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.status = "success";
      state.token = token;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.user = {};
      state.token = "";
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      delete Axios.defaults.headers.common["Authorization"];
    }
  },
  actions: {
    authLogin({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        const instance = Axios.create({
          baseURL: process.env.VUE_APP_AUTH_URL
        });
        instance
          .post("login", user)
          .then(resp => {
            console.log(resp.data);
            const token = resp.data.access_token;
            /*   const user = resp.locales.locales.user;*/
            localStorage.setItem("token", token);
            /*   localStorage.setItem("user", JSON.stringify(user));*/
            Axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
            commit("setToken", token);
            /*        commit("setUser", user);*/
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            localStorage.removeItem("token");
            /*    localStorage.removeItem("user");*/
            reject(err);
          });
      });
    },
    authLogout({ commit }) {
      commit("logout");
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userData: state => state.user,
    authStatus: state => state.status
  }
});
